import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const MSG = { submit: "Submitted for approval", reopen: "Plan reopened for changes" };

export const usePlan = (path, fy, toData) => {
  const [d, setD] = useState(null);
  const [data, setData] = useState(null);
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    if (!path || !fy) return;
    api.get(path, { params: { fy } }).then((r) => { setD(r.data); setData(toData(r.data.plan.data)); setDirty(false); }).catch((e) => toast.error(errMsg(e)));
  }, [path, fy, toData]);
  useEffect(() => { load(); }, [load]);
  const edit = (fn) => { setData((x) => fn(x)); setDirty(true); };
  const save = (payload) => {
    setBusy(true);
    return api.put(path, { data: payload }, { params: { fy } })
      .then((r) => { setD((x) => ({ ...x, plan: r.data })); setData(toData(r.data.data)); setDirty(false); toast.success("Draft saved"); return true; })
      .catch((e) => { toast.error(errMsg(e)); return false; }).finally(() => setBusy(false));
  };
  const act = (kind, body) => {
    setBusy(true);
    return api.post(`${path}/${kind}`, body, { params: { fy } })
      .then((r) => { setD((x) => ({ ...x, plan: r.data })); toast.success(MSG[kind] || (body.approve ? "Plan approved" : "Sent back for changes")); return true; })
      .catch((e) => { toast.error(errMsg(e)); return false; }).finally(() => setBusy(false));
  };
  return { d, data, dirty, busy, edit, save, act };
};
